export default __webpack_public_path__ + "static/media/custom_image_2.b4e86cc7.png";